import { Group, Title } from "@mantine/core";
import { IconHistory } from "@tabler/icons-react";
import { Link } from "react-router";
import { IconButton } from "../../../../mantine/components/IconButton/IconButton";

interface PageHeaderProps {
  title: string;
  historyButtonUrl?: string;
}

function PageHeader({ title, historyButtonUrl }: PageHeaderProps) {
  return (
    <Group justify="space-between" mb={24}>
      <Title
        c="#3f4047"
        ff={"Roboto, sans-serif"}
        fw={500}
        fz={"1.55em"}
        order={3}
      >
        {title}
      </Title>

      {historyButtonUrl && (
        <IconButton
          component={Link}
          icon={IconHistory}
          size="xs"
          to={historyButtonUrl}
          variant="outline"
        >
          Historie
        </IconButton>
      )}
    </Group>
  );
}

export { PageHeader, PageHeaderProps };
